/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropentriestitle2Inputs */

const en_dropentriestitle2 = /** @type {(inputs: Dropentriestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entries`)
};

const de_dropentriestitle2 = /** @type {(inputs: Dropentriestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahmen`)
};

/**
* | output |
* | --- |
* | "Entries" |
*
* @param {Dropentriestitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropentriestitle2 = /** @type {((inputs?: Dropentriestitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropentriestitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropentriestitle2(inputs)
	return de_dropentriestitle2(inputs)
});
export { dropentriestitle2 as "dropEntriesTitle" }